export const borderThin = '1px';

export const borderMedium = '2px';

export const borderBold = '6px';
